import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ClientService } from "../../Services/client.service";
import { Client } from "../../Models/client";
import { WiSnackBarService } from "../../Services/wi-snackBar.service";
import { PopUpConfirmationComponent } from "../pop-up-confirmation/pop-up-confirmation.component";
import { Router } from "@angular/router";
import { GoogleTagManagerService } from "../../Services/google-tag-manager.service";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { LoginComponent } from "admin-common";
import { AuthenticationService } from "src/app/Services/authentification/services/authentication.service";
import { TranslateService } from "@ngx-translate/core";

export class ClientIsPending {
  message?: string;
}
@Component({
    selector: "app-registration-dialog",
    templateUrl: "./registration-dialog.component.html",
    styleUrls: ["./registration-dialog.component.scss"],
    standalone: false
})
export class RegistrationDialogComponent {
  @Output() login: EventEmitter<boolean> = new EventEmitter();
  @Output() onSubscribe: EventEmitter<boolean> = new EventEmitter();
  theme: ProjectTheme = "ABC";
  client?: Client;

  registerError: { status?: number; message: string } | null = null;
  snackbarText: string = "";

  loading = false;
  showSnackbar: boolean = false;
  snackbarTheme: string = "";

  step: number = 1;
  currentStep!: number;
  showSubscriptionModal: boolean = true;
  /**
   * Subsciption successed popup
   */
  showSubscriptionSuccessModal: boolean = false;
  userEmail: string = "";

  constructor(
    private clientService: ClientService,
    private route: Router,
    public googleTagManagerService: GoogleTagManagerService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
  ) {}
  closeDialog() {
    this.onSubscribe.emit(false);
  }

  onSignUp(userData: {
    nom: string;
    prenom: string;
    email: string;
    password: string;
  }) {
    this.loading = true;
    const clientPayload: Client = {
      firstname: userData.prenom,
      lastname: userData.nom,
      email: userData.email,
      password: userData.password,

      username: null,
      gender: "Male",
      phone: null,
      activity: null,
      articleNumber: null,
      registerNumber: null,
      state: null,
      taxNumber: null,
      type: null,
      cartId: null,
      enabled: null,
      provider: null,
    };

    this.clientService.add(clientPayload).subscribe(
      () => {
        this.userEmail = clientPayload.email;
        this.showSubscriptionSuccessModal = true;
        this.showSubscriptionModal = false;
      },
      (error) => {
        this.loading = false;

        if (error?.status === 400) {
          this.snackbarTheme = "alert";
          this.snackbarText = this.translate.instant(
            "globalUi.registration.emailExists",
          );

          this.showSnackbar = true;
          this.step = 1;
          this.registerError = {
            status: 400,
            message: this.snackbarText,
          };
          setTimeout(() => {
            this.showSnackbar = false;
          }, 3000);
        } else {
          this.registerError = error;
        }
      },
    );
  }

  onGoToLogIn() {
    this.login.emit(true);
  }

  onStepChange() {
    this.step = 2;
  }

  /**
   * @description get a new account confirmation mail, if the user didn't recieve the first one
   * @param {string} email user email
   */
  sendConfirmationEmail() {
    this.authenticationService.getConfirmationMail(this.userEmail).subscribe({
      next: (response: any) => {
        if (response.message === "client confirmed") {
          this.showSubscriptionSuccessModal = false;
          this.snackbarTheme = "success";
          this.snackbarText = this.translate.instant(
            "globalUi.registration.alreadyConfirmed",
          );
          this.showSnackbar = true;

          setTimeout(() => {
            this.showSnackbar = false;
          }, 3000);

          setTimeout(() => {
            this.onGoToLogIn();
          }, 1000);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
}
